import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCircleMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z" })
});
export default SvgIconCircleMinus;
